import { useState } from "react";

const COLORS = ["#D4AF37", "#E5C564", "#FDFBF7", "#22c55e", "#b45309", "#f59e0b"];

export function Confetti({ count = 70 }) {
  const [pieces] = useState(() =>
    Array.from({ length: count }).map((_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 0.5,
      duration: 2.4 + Math.random() * 1.6,
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      w: 6 + Math.random() * 8,
      h: 8 + Math.random() * 10,
      rotate: Math.random() * 360,
      drift: (Math.random() * 2 - 1) * 90,
      round: Math.random() > 0.6,
    }))
  );

  return (
    <div className="pointer-events-none fixed inset-0 z-50 overflow-hidden" data-testid="confetti" aria-hidden="true">
      {pieces.map((p) => (
        <span
          key={p.id}
          className="confetti-piece"
          style={{
            left: `${p.left}%`,
            width: `${p.w}px`,
            height: `${p.h}px`,
            background: p.color,
            borderRadius: p.round ? "50%" : "2px",
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
            "--drift": `${p.drift}px`,
            "--rot": `${p.rotate}deg`,
          }}
        />
      ))}
    </div>
  );
}
